var medicineList = [
  {
    name: "Medicine Type 1",
    manufacturerName: "Manufacturer 1",
    price: 10,
    stock: 10,
    discount: 10,
  },
  {
    name: "Medicine Type 2",
    manufacturerName: "Manufacturer 2",
    price: 30,
    stock: 10,
    discount: 10,
  },
  {
    name: "Medicine Type 3",
    manufacturerName: "Manufacturer 3",
    price: 20,
    stock: 10,
    discount: 10,
  },
  {
    name: "Medicine Type 4",
    manufacturerName: "Manufacturer 4",
    price: 50,
    stock: 10,
    discount: 10,
  },
  {
    name: "Medicine Type 5",
    manufacturerName: "Manufacturer 5",
    price: 60,
    stock: 10,
    discount: 10,
  },
];

var emplList = [
  {
    firstName: "Employee",
    lastName: "One",
    dob: "dd-mm-yy",
    gender: "Male",
    experience: 1,
    password: "test-one",
  },
  {
    firstName: "Employee",
    lastName: "Two",
    dob: "dd-mm-yy",
    gender: "Female",
    experience: 2,
    password: "test-two",
  },
  {
    firstName: "Employee",
    lastName: "Three",
    dob: "dd-mm-yy",
    gender: "Female",
    experience: 3,
    password: "test-three",
  },
  {
    firstName: "Employee",
    lastName: "Four",
    dob: "dd-mm-yy",
    gender: "Male",
    experience: 4,
    password: "test-four",
  },
];

var orderList = [
  {
    orderId: "1629710727511",
    customerName: "Customer 1",
    customerNo: 9835462891,
    products: "Medicine Type 1",
    quantityEachProd: 2,
    totalAmount: 20,
  },
  {
    orderId: "1629710727512",
    customerName: "Customer 2",
    customerNo: 9835462892,
    products: "Medicine Type 3",
    quantityEachProd: 3,
    totalAmount: 60,
  },
  {
    orderId: "1629710727513",
    customerName: "Customer 3",
    customerNo: 9835462893,
    products: "Medicine Type 2",
    quantityEachProd: 1,
    totalAmount: 30,
  },
];

var adminCreds = [
  {
    id: "test-admin",
    pass: "test-admin",
  },
];
var salesCreds = [
  {
    id: "test-sales",
    pass: "test-sales",
  },
];

export var medicineList;
export var emplList;
export var orderList;
export var adminCreds;
export var salesCreds;
